import { Stack, Grid } from '@mui/material';
import { useContext } from 'react';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import WorkflowEngineHeader from '../../WorkflowEngine/WorkflowEngineHeader';
import WorkflowSubHeader from '../WorkflowSubHeader';
import NoAccessView from '../Entry/NoAccessView';
import FormEntryView from '../FormEntryView';
import CompletionScreen from '../CompletionScreen';

export default () => {
  const { state } = useContext(WorkflowEngineContext);

  const { hasAccessToWorkflow, isWorkflowCompleted } = state;

  const viewRenderControler = () => {
    if (!hasAccessToWorkflow) {
      return (
        <Grid item xs={12}>
          <NoAccessView />
        </Grid>
      );
    }

    if (isWorkflowCompleted) {
      return <CompletionScreen />;
    }

    return <FormEntryView />;
  };

  return (
    <Stack>
      <WorkflowEngineHeader />
      <WorkflowSubHeader />
      <Grid container spacing={3} sx={{ padding: '15px 30px 30px 30px' }}>
        {viewRenderControler()}
      </Grid>
    </Stack>
  );
};
